const setJobHiredDefaultValue = (payload) => ({
    type: 'SET_JOB_HIRE_DEFAULT_VALUE',
    payload,
  })
export { setJobHiredDefaultValue }